export default "__VITE_ASSET__BQDLxgN1__"